import RaisedButton from "./raisedButton";
import styled from "styled-components";

const AutoSizedButton = styled(RaisedButton)<{ $fullWidth?: boolean }>`
  padding: 0.5rem 1rem;
  min-width: unset;
  min-height: 2.5rem;
  ${({ $fullWidth }) => $fullWidth && `width: 100%;`}
`;

export default AutoSizedButton;
